import Vue from 'vue/dist/vue.js';
import bioCard from './vue-components/bio-card.js';

// Fetch Blog Posts from WP REST API
let app = new Vue({
    el: '#people-app',
    delimiters: ['${', '}'],
    bioCard,
    data: {
        url: null,
        loaded: false,
        totalPagesLoaded: 1,
        perPage: 100,
        totalPages: null,
        headers: {
            totalEntires: null,
            totalQueryPages: null,
        },
        settings:{
            category: 'students',
            query:{
                postType: 'community',
                orderby: 'ASC',
            },
        },
        categories:[],
        sub_categories:[{
            name: "Other",
            orderby: 999
        }],
        classes:[],
        people: [],
        loaded_people: [],
        displayData: [],
    },
    filters:{
        dateFormat: function( ){}
    },
    mounted: function(){
        const t = this;
        t.$data.url = window.location.href;

        t.queryCategories({});
    },
    methods:{
        queryCategories: function( params ){
            const t = this;

            let fetchURL = "/wp-json/wp/v2/people_catgories?per_page=25";

            Array.prototype.sortOn = function(key){
                this.sort(function(a, b){
                    if(a[key] < b[key]){
                        return -1;
                    }
                    else if(a[key] > b[key]){
                        return 1;
                    }
                    return 0;
                });
            }

            fetch( fetchURL ).then(function (response) {
                if(response.ok){
                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                for (var i = data.length - 1; i >= 0; i--) {
                    t.$data.categories.push({
                        id: parseInt(data[i].id),
                        slug: data[i].slug,
                        hash: '#'+data[i].slug,
                        orderby: parseInt(data[i].acf.sort_order),
                        name: data[i].name
                    });
                };

                t.$data.categories.sortOn("orderby");

                if (window.location.hash){
                    t.$data.settings.category = window.location.hash.replace('#','');
                }
                else{
                    t.$data.settings.category = t.$data.categories[0].slug;
                }

                console.log('Query Categories Complete!');

                t.querySubCategories({});

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        querySubCategories: function( params ){
            const t = this;

            let fetchURL = "/wp-json/wp/v2/people_sub_catgories?per_page=25";

            Array.prototype.sortOn = function(key){
                this.sort(function(a,b){
                    if(a[key] < b[key]){
                        return -1;
                    }
                    else if(a[key] > b[key]){
                        return 1;
                    }
                    return 0;
                });
            }

            fetch( fetchURL ).then(function (response) {
                if(response.ok){
                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                for (var i = data.length - 1; i >= 0; i--) {
                    t.$data.sub_categories.push({
                        id: parseInt(data[i].id),
                        slug: data[i].slug,
                        hash: '#'+data[i].slug,
                        orderby: parseInt(data[i].acf.sort_order),
                        name: data[i].name
                    });
                };

                t.$data.sub_categories.sortOn("orderby");

                console.log('Query Sub Categories Complete!', t.$data.sub_categories);

                t.queryClassYears({});

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        queryClassYears: function( params ){
            const t = this;

            let fetchURL = "/wp-json/wp/v2/classes?per_page=50";

            Array.prototype.sortOn = function(key){
                this.sort(function(a, b){
                    if(a[key] < b[key]){
                        return -1;
                    }
                    else if(a[key] > b[key]){
                        return 1;
                    }
                    return 0;
                });
            }

            fetch( fetchURL ).then(function (response) {
                if(response.ok){
                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                for (var i = data.length - 1; i >= 0; i--) {
                    t.$data.classes.push({
                        id: parseInt(data[i].id),
                        slug: data[i].slug,
                        name: data[i].name,
                        yearInt: parseInt(data[i].name),
                    });
                };

                t.$data.classes.sortOn("yearInt");

                console.log('Query Class Years Complete!');

                t.queryAPI({});

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        queryAPI: function( params ){
            const t = this;

            let fetchURL = '/wp-json/wp/v2/'+t.$data.settings.query.postType+'/';
                fetchURL += '?per_page=100&page=' + t.$data.totalPagesLoaded;
                fetchURL += '&custom_order_by=' + t.$data.settings.query.orderby;

            if( params.categories ){
                fetchURL += '&category_id=' + encodeURIComponent(JSON.stringify( params.categories ));
            }

            if( params.classes ){
                fetchURL += '&class_year_id=' + encodeURIComponent(JSON.stringify(  params.classes ));
            }

            if( params.sortClause ){
                fetchURL += '&sortClause=' + encodeURIComponent(  params.sortClause );
            }

            if( params.sortKey ){
                fetchURL += '&sortKey=' + encodeURIComponent(  params.sortKey );
            }

            fetch( fetchURL ).then(function (response) {
                if(response.ok){

                    response.headers.forEach( function(element, index) {
                        if(index==='x-wp-total'){
                            t.$data.headers.totalEntires = parseInt(element);
                        }

                        if(index==='x-wp-totalpages'){
                            t.$data.headers.totalQueryPages = parseInt(element);
                        }
                    });

                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                t.$data.totalPages = Math.ceil(t.$data.headers.totalEntires / t.$data.perPage);
                t.$data.totalPagesLoaded++;

                if(t.$data.totalPages == 1){
                    // console.log('1: only one page so only parse data');
                    for(let i = 0, length1 = data.length; i < length1; i++){
                        t.$data.loaded_people.push( data[i] );
                    }
                    t.parseData( t.$data.loaded_people );
                }
                else if(t.$data.totalPagesLoaded <= t.$data.totalPages + 1){
                    // console.log('2: Loop and get all entries');
                    for(let i = 0, length1 = data.length; i < length1; i++){
                        t.$data.loaded_people.push( data[i] );
                    }
                    t.queryAPI({});
                }

                if(t.$data.totalPagesLoaded == t.$data.totalPages + 1){
                    // console.log('3: ok, parse data', t.$data.loaded_people.length);
                    t.parseData( t.$data.loaded_people );
                }

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        parseData: function( data ){
            const t = this;

            t.$data.people = [];

            if(data.length ){
                for(let i = 0, length1 = data.length; i < length1; i++){
                    let personData = {
                        index: i,
                        modified: data[i].modified,
                        id: data[i].id,
                        slug: data[i].slug,
                        url: t.$data.url + data[i].slug,
                        rawLink: data[i].link,

                        featured_image: data[i].featured_media,

                        first_name: data[i].acf.first_name,
                        middle_name_initial: data[i].acf.middle_name_initial,
                        last_name: data[i].acf.last_name,

                        area_of_expertise_or_role: data[i].acf.area_of_expertise_or_role,
                        personal_link: data[i].acf.personal_link,
                        social_media: data[i].acf.social_media,
                        biography: data[i].acf.biography,

                        classes: data[i].classes,
                        category:  data[i].people_catgories,
                        sub_catgories:  data[i].people_sub_catgories
                    };

                    t.$data.people.push(personData)
                };
            }

            t.buildDataSet();
        },

        buildDataSet: function(){
            const t = this;
            let finalArray = [];

            Array.prototype.sortOn = function(key){
                this.sort(function(a, b){
                    if(a[key] < b[key]){
                        return -1;
                    }
                    else if(a[key] > b[key]){
                        return 1;
                    }
                    return 0;
                });
            }

            for (var i = t.$data.categories.length - 1; i >= 0; i--) {
                let categoryGroup = {
                    orderby: t.$data.categories[i].orderby,
                    slug: t.$data.categories[i].slug,
                    category:{
                        name: t.$data.categories[i].name,
                        group: []
                    }
                };

                if(t.$data.categories[i].slug == 'students' ){
                    for (var j = t.$data.classes.length - 1; j >= 0; j--) {
                        let tmpGroup = {
                            people: [],
                            year: t.$data.classes[j].name
                        };

                        if(t.$data.classes[j].name == "2015"){
                            // console.log(t.$data.classes[j].name);
                        }


                        for (var k = t.$data.people.length - 1; k >= 0; k--) {
                            if(t.$data.people[k].category.length){

                                if(t.$data.people[k].category[0].slug){
                                    if(t.$data.people[k].category[0].slug == 'students'){
                                        if(t.$data.people[k].classes.length){
                                            if(t.$data.people[k].classes[0].slug == t.$data.classes[j].slug){
                                                tmpGroup.people.push( t.$data.people[k]  );
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        categoryGroup.category.group.push( tmpGroup );

                    }
                }
                else if(t.$data.categories[i].slug == 'faculty_and_staff' ){
                    for (var j = t.$data.sub_categories.length - 1; j >= 0; j--) {
                        let tmpGroup = {
                            people: [],
                            sub_category: t.$data.sub_categories[j].name
                        };

                        for (var k = t.$data.people.length - 1; k >= 0; k--) {

                            if(t.$data.people[k].category.length){

                                if(t.$data.people[k].category[0].slug){
                                    if(t.$data.people[k].category[0].slug == 'faculty_and_staff'){
                                        if(t.$data.people[k].sub_catgories.length){
                                            if(t.$data.people[k].sub_catgories[0].slug == t.$data.sub_categories[j].slug){
                                                tmpGroup.people.push( t.$data.people[k]  );
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        categoryGroup.category.group.push( tmpGroup );

                    }
                }
                else if(t.$data.categories[i].slug == 'mentors' ){
                    let tmpGroup = {
                        people: []
                    };

                    for (var k = t.$data.people.length - 1; k >= 0; k--) {

                        if(t.$data.people[k].category.length){

                            if(t.$data.people[k].category[0].slug){
                                if(t.$data.people[k].category[0].slug == 'mentors'){
                                    tmpGroup.people.push( t.$data.people[k]  );
                                }
                            }
                        }
                    }

                    categoryGroup.category.group.push( tmpGroup );
                }


                finalArray.push( categoryGroup );
            }

            finalArray.sortOn("orderby");

            t.$data.displayData = finalArray;
            t.$data.loaded = true;
        },

        setActive: function(e, slug){
            console.log('setActive', e);
            const t = this;

            t.$data.settings.category = slug;
        }
    }
});